import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import ReactSwitch from 'react-switch';
import { WrappedFieldInputProps } from 'redux-form';
import Text from './Text';

type SwitchProps = {
  input: WrappedFieldInputProps;
  label?: string;
  placeholder?: string;
  initialValue?: boolean;
  disabled?: boolean;
};

const Switch = ({
  input: { name, checked = false, onChange },
  label,
  placeholder,
  initialValue,
  disabled
}: SwitchProps) => {
  useEffect(() => {
    onChange(initialValue);
  }, [onChange, initialValue]);

  const onSwitchChange = useCallback(
    nextChecked => {
      onChange(nextChecked);
    },
    [onChange]
  );
  return (
    <div className={classNames('flex mb-4 items-center')}>
      <ReactSwitch
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onSwitchChange}
        uncheckedIcon={false}
        checkedIcon={false}
      />
      <Text as="label" className="ml-4 text-xs">
        {label || placeholder}
      </Text>
    </div>
  );
};

Switch.propTypes = {
  input: PropTypes.shape({
    checked: PropTypes.bool,
    onChange: PropTypes.func
  }).isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  initialValue: PropTypes.bool,
  disabled: PropTypes.bool
};

Switch.defaultProps = {
  label: '',
  placeholder: '',
  initialValue: false,
  disabled: false
};

export default Switch;
